module.exports = __webpack_public_path__ + "img/matic.095ffad2.svg";